module.exports = "pegasus/assets/tech/small/7.jpg";